








import Vue from 'vue'
import Component from 'vue-class-component'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'


@Component({
  components: {
    UserInterface2FolderDataTable
  }
})
class AccountResourceItem2AccountStatistics extends Vue {

}

export default AccountResourceItem2AccountStatistics


